// Copyright © 2021 Move Closer
import { AnalyticsModule } from '@/modules/analytics';
import { ContentModule } from '@content/index';
import { FormModule } from '@/modules/forms';
import { ProfileModule } from '@profile/index';
import { RootModule } from '@root/index';
import { SubscriptionModule } from '@subscription/index';
export const AppModules = [AnalyticsModule, ContentModule, FormModule, ProfileModule, RootModule, SubscriptionModule];
